<template>
    <div class="list-item goToCruiseDetail hp-content" @click="onCruiseClicked">
        <div class="list-item-img-con">
            <a class="external" @click.stop="onCruiseClicked">
                <img class="list-item-img"
                    :src="cruiseInfo.pcImage">
                <div class="list-item-bottom" v-if="cruise.description && cruise.description.length > 0">{{cruise.description}}</div>
            </a>
        </div>
        <div class="list-item-con">
            <div class="item-title-con">
                <div class="item-title float-left">{{cruiseInfo.cruiseName}}</div>
                <div class="like-con" :class="{ active: inWish}" @click.stop="onWishListClick(cruiseInfo)">
                    <img class="inWishlistImage cruise--list__Wish-img"
                        src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/like-checked.jpg">
                    <img class="notInWishlistImage cruise--list__Wish-img"
                        src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/like-def.jpg">

                    <div style="line-height: 12px;" class="wishlistCount">{{collections}}</div>
                </div>
            </div>
            <div class="item-info-text">
                 {{cruiseInfo.routeDays}}天{{cruiseInfo.routeDays-1}}晚
                <span style="display: inline-block; margin-left: 18px;">{{cruiseInfo.shipCNName}}</span>
            </div>
            <div class="item-info-text">
                <div class="float-left">
                    {{cruiseInfo.sailDateBegin}} <i>—</i> {{cruiseInfo.sailDateEnd}}
                </div>
                <div class="item-more-date" @click.stop="onMoreSailDateClicked">
                    <img class="float-left" style="margin-right: 5px"
                        src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-date-1.jpg">
                    <div class="float-left fw-400">更多日期</div>
                </div>
            </div>

            <div style="overflow: hidden;" v-if="cruiseInfo.tags&&cruiseInfo.tags.length>0">
                <div class="list-search-input-tag-con">
                    <CruiseTag 
                        v-for="(tag, i) in cruiseInfo.tags" :key="('cruiseInfoTag_' + i)"
                        :tag="tag"
                        :index="new Date().getTime() + '_partnerHotCruiseItem_' + i"
                    />
                </div>
            </div>

            <div class="item-btn-con" v-if="cruise.discountAmount>0">
                <div class="item-btn goToCruiseDetail"
                    @click.stop="onCruiseClicked">立即预订</div>
                <div class="item-price fw-400">
                    <a class="external goToCruiseDetail"
                        @click.stop="onCruiseClicked"
                        data-type="hp">
                        <span>{{priceType}}</span>
                        <span style="color: #ffa70d">￥</span>
                        <span class="item-price-number">{{cruise.discountAmount.toFixed(0)}}</span>
                        /人起
                    </a>

                </div>
            </div>
            <div class="item-btn-con" v-else>
                    <div class="item-price fw-400">售罄</div>
            </div>

        </div>
    </div>
</template>


<script>
import api from '@/api'
import nrpConfig from '@/utilities/nrpConfig'
const CruiseTag = () => import('@/components/Cruise/CruiseTag')
export default {
    name: "PartnerHotCruiseItem",
    components: {
        CruiseTag
    },
    props: {
        cruise: {
            type: Object
        },
        rowCruiseSearchHandler: {
            type: Function
        },
        showMoreSailDatePopup: {
            type: Function
        },
        showLoginPopup: {
            type: Function
        }
    },
    data () {
        return {
            inWish: false,
            collections: 0
        }
    },
    beforeMount () {
        this.inWish = this.cruiseInfo.inWish
        this.collections = this.cruiseInfo.collections
    },
    methods: {
        onCruiseClicked () {
                this.$router.push({
                    name: "CruiseDetail",
                    query: {
                        shipCode: this.cruise.shipCode,
                        sailDate: this.sailDate
                    }
                })
        },
        onWishListClick (cruise) {
            if (this.inWish) {
                this.deleteWishList(cruise)
            } else {
                this.addWishList(cruise)
            }
        },
        async addWishList (cruise) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.showLoginPopup(()=> {
                            self.addWishList(cruise)
                        })
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: cruise.cruiseId,
                source: 'PC'
            }
            this.$loading.show()
            const { success } = await api.cruise.addWishList(requestData)
            if (success) {
                this.inWish = true
                this.collections++
            }
            this.$loading.hide()
        },
        async deleteWishList (cruise) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.showLoginPopup(()=> {
                            self.deleteWishList(cruise)
                        })
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: cruise.cruiseId,
                source: 'PC'
            }
            this.$loading.show()
            const { success } = await api.cruise.deleteWishList(requestData)
            if (success) {
                this.inWish = false
                if (this.collections > 0) {
                    this.collections--
                }
            }
            this.$loading.hide()
        },
        onMoreSailDateClicked () {
            const cruise = {
                shipCode: this.cruise.shipCode,
                sailDate: this.sailDate,
                cruiseName: this.cruiseInfo.cruiseName,
                isRow: this.cruise.isRow
            }
            this.showMoreSailDatePopup(cruise)
        }
    },
    computed: {
        sailDate () {
            let sailDate = this.cruise.sailDate + ""
            if (sailDate && sailDate.length > 10) {
                sailDate = sailDate.substring(0, 10)
            }
            return sailDate
        },
        cruiseInfo () {
            return this.cruise.cruise || {}
        },
        priceType () {
            if (this.cruiseInfo.isRow) {
                return "单船票"
            } else if (this.cruiseInfo.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.priceType
            } else if (this.cruiseInfo.isnrpPrice) {
                return nrpConfig.nrp.priceType
            }
            return nrpConfig.rp.priceType
        }
    }
}
</script>

<style lang="less" scoped>
.list-item {
    background-color: #fff;
    margin-bottom: 30px;
    padding: 10px;
    overflow: hidden;
    position: relative;
    box-shadow: 0px 0px 14px 3px rgba(46, 65, 80, 0.1);
    box-sizing: border-box;
    border: solid 2px transparent;
    .list-item-img-con {
        width: 237px;
        height: 239px;
        position: relative;
        float: left;
        img {
            width: 100%;
            height: 100%;
        }
        .list-item-bottom {
            width: 100%;
            padding: 10px 0;
            background: linear-gradient(to bottom, rgba(40,43,44,.3), #282b2c );
            position: absolute;
            bottom: 0px;
            left: 0px;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
        }
    }
    .list-item-con {
        margin-left: 18px;
        width: 640px;
        float: left;
        .item-title-con {
            font-size: 22px;
            line-height: 30px;
            color: #282b2c;
            overflow: hidden;
            .item-title {
                max-width: 605px;
                margin-top: 5px;
                font-weight: 600;
            }
            .like-con {
                font-size: 12px;
                color: #747d80;
                float: right;
                text-align: center;
                cursor: pointer;
                position: absolute;
                top: 7px;
                right: 14px;
                .inWishlistImage {
                    display: none;
                }
                .notInWishlistImage {
                    display: inline;
                }
            }
            .like-con.active {
                .inWishlistImage {
                    display: inline;
                }
                .notInWishlistImage {
                    display: none;
                }
            }
        }
    }
    .item-info-text {
        font-size: 14px;
        color: #282b2c;
        overflow: hidden;
        margin-top: 5px;
        font-weight: 600;
        .item-more-date {
            color: #006ab9;
            margin-left: 8px;
            float: left;
            line-height: 16px;
            margin-top: 3px;
            cursor: pointer;
        }

    }
    
    .item-btn-con {
        position: absolute;
        margin-top: 14px;
        float: right;
        right: 13px;
        bottom: 10px;
        min-width: 300px;
        .item-btn {
            width: 196px;
            height: 50px;
            line-height: 50px;
            background-color: #fbc500;
            font-size: 22px;
            color: #282b2c;
            text-align: center;
            float: right;
            font-weight: 500;
            cursor: pointer;
        }
        .item-price {
            font-size: 16px;
            color: #282b2c;
            position: absolute;
            top: -35px;
            right: 0;
            a {
                color: #282b2c;
            }
            a:hover, a:focus {
                text-decoration: none;
            }
            .item-price-number {
                color: #ffa70d;
                font-size: 24px;
                font-weight: bold;
                letter-spacing: 1px;
            }
        }
    }
}

.list-item:hover {
    cursor: pointer;
    border: solid 2px #fbc300;
}
</style>